import type { CortesGeometry, CortesPresetId } from './types';
import { DEFAULT_CORTES_GEOMETRY } from './cortesDefaults';

export type { CortesPresetId };

export const CORTES_PRESET_IDS: readonly CortesPresetId[] = [
  'caixa-vermelha',
  'barra-branca',
];

export function isCortesPresetId(value: unknown): value is CortesPresetId {
  return typeof value === 'string'
    && (CORTES_PRESET_IDS as readonly string[]).includes(value);
}

/** Picker highlight for a stored Cortes config. Does not rewrite the row. */
export function resolveCortesPreset(config: { preset?: string | null }): CortesPresetId {
  return isCortesPresetId(config.preset) ? config.preset : 'caixa-vermelha';
}

/** Text Box fills in bottom photo slots omitted from older saved geometry. */
export function resolveCortesGeometry(config: {
  preset?: string | null;
  geometry?: CortesGeometry | null;
}): CortesGeometry {
  const g = config.geometry ?? DEFAULT_CORTES_GEOMETRY;
  if (resolveCortesPreset(config) !== 'caixa-vermelha') return g;
  return {
    ...g,
    photo3: g.photo3 ?? DEFAULT_CORTES_GEOMETRY.photo3,
    photo4: g.photo4 ?? DEFAULT_CORTES_GEOMETRY.photo4,
    clip: { ...g.clip, x: 0, w: 1 },
  };
}
